import { WidgetPreference } from '../../types/state';

// Dummy API implementation for Home Screen Widget Preferences
export interface WidgetPreferencesResponse {
  preferences: WidgetPreference[];
}

const mockPreferences: WidgetPreference[] = [
  {
    widgetId: 'widget-001',
    isHidden: true,
    createdAt: '2026-05-21T08:41:50.835Z',
    updatedAt: '2026-05-21T08:41:50.835Z',
  },
  {
    widgetId: 'widget-002',
    isHidden: true,
    createdAt: '2026-05-21T08:42:18.830Z',
    updatedAt: '2026-05-21T08:42:18.830Z',
  },
  {
    widgetId: 'widget-003',
    isHidden: false,
    createdAt: '2026-05-21T08:42:22.890Z',
    updatedAt: '2026-05-21T08:42:42.572Z',
  },
  {
    widgetId: 'widget-004',
    isHidden: true,
    createdAt: '2026-05-21T08:42:26.224Z',
    updatedAt: '2026-05-21T08:42:26.224Z',
  },
];

export const fetchWidgetPreferences =
  async (): Promise<WidgetPreferencesResponse> => {
    // Simulate network latency
    await new Promise((resolve) => setTimeout(resolve, 500));
    return { preferences: mockPreferences };
  };

export const patchWidgetPreference = async (
  widgetId: string,
  isHidden: boolean
): Promise<void> => {
  // Simulate network latency
  await new Promise((resolve) => setTimeout(resolve, 500));

  // Return successfully
  return;
};
